'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$33() {
  this.bhc = null;
  this.bha = null;
  this.bhb = false;
  this.bh8 = null;
  this.bh9 = false;
  this.bhd = false;
  this.bhe = false;
  this.bhc = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$33 as $c_Lpresto_PrestoRouter$$anon$33 };
$p = $c_Lpresto_PrestoRouter$$anon$33.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$33;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$33() {
}
export { $h_Lpresto_PrestoRouter$$anon$33 as $h_Lpresto_PrestoRouter$$anon$33 };
$h_Lpresto_PrestoRouter$$anon$33.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bhc;
});
$p.t = (function() {
  if ((!this.bhb)) {
    this.bha = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bhb = true;
  }
  return this.bha;
});
$p.ae = (function() {
  if ((!this.bh9)) {
    this.bh8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bh9 = true;
  }
  return this.bh8;
});
$p.w = (function() {
  if ((!this.bhe)) {
    this.bhd = false;
    this.bhe = true;
  }
  return this.bhd;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$33 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$33, "presto.PrestoRouter$$anon$33", ({
  NY: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$33 as $d_Lpresto_PrestoRouter$$anon$33 };
//# sourceMappingURL=presto.-Presto-Router$$anon$33.js.map
